/**
 * SERPROMAQ - Módulo de Reseñas, Testimonios y Calificación en Vivo
 * 26+ Reseñas auténticas y diversas, soporte de subida de fotos por el usuario,
 * persistencia local y sincronización con base de datos en la nube (Firestore / Storage).
 */

import { 
  db, 
  storage, 
  collection, 
  addDoc, 
  serverTimestamp, 
  ref, 
  uploadBytes, 
  getDownloadURL 
} from './firebase-config.js';

export function initReviewsModule() {
  const reviewsTrack = document.getElementById('reviewsCardsTrack');
  const prevBtn = document.getElementById('reviewsPrevBtn');
  const nextBtn = document.getElementById('reviewsNextBtn');
  const filterBtns = document.querySelectorAll('.reviews-filter-btn');
  const paginationInfo = document.getElementById('reviewsPaginationInfo');
  const dotsContainer = document.getElementById('reviewsDots');

  if (!reviewsTrack) return;

  let cards = Array.from(reviewsTrack.querySelectorAll('.review-card-modern'));
  let activeFilter = 'todos';
  let currentPage = 0;
  let cardsPerPage = getCardsPerPage();

  function getCardsPerPage() {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1200) return 2;
    return 3;
  }

  function getVisibleCards() {
    return cards.filter(card => {
      if (activeFilter === 'todos') return true;
      return card.getAttribute('data-service') === activeFilter;
    });
  }

  function updateCounts() {
    const counts = {
      todos: cards.length,
      alquiler: cards.filter(c => c.getAttribute('data-service') === 'alquiler').length,
      mantenimiento: cards.filter(c => c.getAttribute('data-service') === 'mantenimiento').length,
      venta: cards.filter(c => c.getAttribute('data-service') === 'venta').length,
      repuestos: cards.filter(c => c.getAttribute('data-service') === 'repuestos').length
    };

    filterBtns.forEach(btn => {
      const f = btn.getAttribute('data-filter') || 'todos';
      const badge = btn.querySelector('.filter-count-badge');
      if (badge && counts[f] !== undefined) {
        badge.textContent = counts[f];
      }
    });
  }

  function updateCarousel() {
    const visibleCards = getVisibleCards();
    const totalVisible = visibleCards.length;
    const totalPages = Math.ceil(totalVisible / cardsPerPage) || 1;

    if (currentPage >= totalPages) currentPage = Math.max(0, totalPages - 1);

    // Ocultar todas las tarjetas primero
    cards.forEach(c => {
      c.style.display = 'none';
      c.classList.remove('animate-review-in');
    });

    // Mostrar las tarjetas de la página actual
    const startIndex = currentPage * cardsPerPage;
    const endIndex = Math.min(startIndex + cardsPerPage, totalVisible);

    visibleCards.forEach((card, idx) => {
      if (idx >= startIndex && idx < endIndex) {
        card.style.display = 'flex';
        void card.offsetWidth;
        card.classList.add('animate-review-in');
      }
    });

    // Actualizar paginación de texto
    if (paginationInfo) {
      if (totalVisible === 0) {
        paginationInfo.innerHTML = 'No se encontraron reseñas en esta categoría';
      } else {
        paginationInfo.innerHTML = `Mostrando <strong>${startIndex + 1}-${endIndex}</strong> de <strong>${totalVisible}</strong> reseñas verificadas`;
      }
    }

    // Actualizar botones prev / next
    if (prevBtn) prevBtn.disabled = currentPage === 0;
    if (nextBtn) nextBtn.disabled = currentPage >= totalPages - 1;

    // Actualizar Dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `reviews-dot ${i === currentPage ? 'active' : ''}`;
        dot.setAttribute('aria-label', `Ir a página de reseñas ${i + 1}`);
        dot.addEventListener('click', () => {
          currentPage = i;
          updateCarousel();
        });
        dotsContainer.appendChild(dot);
      }
    }
  }

  // Event Listeners de Filtros
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      activeFilter = btn.getAttribute('data-filter') || 'todos';
      currentPage = 0;
      updateCarousel();
    });
  });

  // Botones Anterior / Siguiente
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentPage > 0) {
        currentPage--;
        updateCarousel();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const visibleCards = getVisibleCards();
      const totalPages = Math.ceil(visibleCards.length / cardsPerPage);
      if (currentPage < totalPages - 1) {
        currentPage++;
        updateCarousel();
      }
    });
  }

  // Listener de Resize con debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newPerPage = getCardsPerPage();
      if (newPerPage !== cardsPerPage) {
        cardsPerPage = newPerPage;
        updateCarousel();
      }
    }, 150);
  });

  // --------------------------------------------------------------------------
  // MODAL PARA DEJAR RESEÑA (INTERACTIVO CON SUBIDA DE FOTO)
  // --------------------------------------------------------------------------
  const reviewModal = document.getElementById('leaveReviewModal');
  const openModalBtns = document.querySelectorAll('.btn-trigger-leave-review');
  const closeModalBtn = document.getElementById('closeLeaveReviewModal');
  const reviewForm = document.getElementById('leaveReviewForm');
  const starRatingInputs = document.querySelectorAll('.star-rating-picker input');
  const ratingTextValue = document.getElementById('selectedRatingText');
  
  const photoInput = document.getElementById('newReviewPhoto');
  const photoPreviewWrap = document.getElementById('reviewPhotoPreviewWrap');
  const photoPreview = document.getElementById('reviewPhotoPreview');
  const photoTextWrap = document.getElementById('reviewPhotoTextWrap');
  const btnRemovePhoto = document.getElementById('btnRemoveReviewPhoto');

  let selectedStars = 5;
  let userSelectedPhotoFile = null;
  let userSelectedPhotoBase64 = null;

  if (openModalBtns.length && reviewModal) {
    openModalBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        reviewModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  function closeReviewModal() {
    if (reviewModal) {
      reviewModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', closeReviewModal);
  }

  if (reviewModal) {
    reviewModal.addEventListener('click', (e) => {
      if (e.target === reviewModal) {
        closeReviewModal();
      }
    });
  }

  // Manejo de Foto del Usuario
  if (photoInput) {
    photoInput.addEventListener('change', (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        alert('Por favor selecciona un archivo de imagen válido (JPG, PNG, WebP).');
        return;
      }

      userSelectedPhotoFile = file;
      const reader = new FileReader();
      reader.onload = (event) => {
        userSelectedPhotoBase64 = event.target.result;
        if (photoPreview && photoPreviewWrap && photoTextWrap && btnRemovePhoto) {
          photoPreview.src = userSelectedPhotoBase64;
          photoPreviewWrap.style.display = 'block';
          photoTextWrap.querySelector('strong').textContent = file.name;
          photoTextWrap.querySelector('span').textContent = `${(file.size / 1024).toFixed(1)} KB • Imagen lista`;
          btnRemovePhoto.style.display = 'flex';
        }
      };
      reader.readAsDataURL(file);
    });
  }

  if (btnRemovePhoto) {
    btnRemovePhoto.addEventListener('click', (e) => {
      e.stopPropagation();
      userSelectedPhotoFile = null;
      userSelectedPhotoBase64 = null;
      if (photoInput) photoInput.value = '';
      if (photoPreview) photoPreview.src = '';
      if (photoPreviewWrap) photoPreviewWrap.style.display = 'none';
      if (photoTextWrap) {
        photoTextWrap.querySelector('strong').innerHTML = '<i class="fa-solid fa-camera" style="color: var(--color-primary);"></i> Adjuntar tu foto (Opcional)';
        photoTextWrap.querySelector('span').textContent = 'Haz clic o arrastra una imagen JPG o PNG';
      }
      btnRemovePhoto.style.display = 'none';
    });
  }

  // Selector de Estrellas
  if (starRatingInputs.length) {
    starRatingInputs.forEach(input => {
      input.addEventListener('change', () => {
        selectedStars = parseInt(input.value, 10);
        if (ratingTextValue) {
          const textMap = {
            5: '5.0 - ¡Excelente servicio y atención! ⭐⭐⭐⭐⭐',
            4: '4.0 - Muy buen servicio ⭐⭐⭐⭐',
            3: '3.0 - Buen servicio ⭐⭐⭐',
            2: '2.0 - Regular ⭐⭐',
            1: '1.0 - Malo ⭐'
          };
          ratingTextValue.textContent = textMap[selectedStars] || `${selectedStars}.0 Estrellas`;
        }
      });
    });
  }

  // Cargar reseñas guardadas previamente por usuarios en LocalStorage
  function loadPersistedUserReviews() {
    try {
      let saved = JSON.parse(localStorage.getItem('serpromaq_user_reviews') || '[]');
      if (Array.isArray(saved) && saved.length > 0) {
        // Filtrar y eliminar reseñas de prueba
        saved = saved.filter(rev => {
          const name = (rev.name || '').toLowerCase();
          const comment = (rev.comment || '').toLowerCase();
          return !name.includes('chelito') && !comment.includes('todo bien prueba') && !comment.includes('prueba');
        });
        localStorage.setItem('serpromaq_user_reviews', JSON.stringify(saved));
        saved.reverse().forEach(rev => {
          renderAndPrependReview(rev, false);
        });
      }
    } catch (e) {
      console.warn('LocalStorage reviews note:', e);
    }
  }

  function renderAndPrependReview(data, animate = true) {
    const { name, role, company, city, service, stars, comment, photoUrl, dateStr } = data;
    const initials = name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() || 'CL';

    const serviceLabels = {
      'alquiler': { title: 'Renta de Flota', class: 'chip-alquiler', icon: 'fa-calendar-check' },
      'mantenimiento': { title: 'Mantenimiento Preventivo', class: 'chip-mantenimiento', icon: 'fa-screwdriver-wrench' },
      'venta': { title: 'Venta de Montacargas', class: 'chip-venta', icon: 'fa-truck-moving' },
      'repuestos': { title: 'Insumos & Repuestos', class: 'chip-repuestos', icon: 'fa-gears' }
    };

    const servInfo = serviceLabels[service] || serviceLabels['alquiler'];

    const newCard = document.createElement('div');
    newCard.className = `review-card-modern ${animate ? 'animate-review-in' : ''}`;
    newCard.setAttribute('data-service', service);

    let starsHtml = '';
    for (let s = 1; s <= 5; s++) {
      starsHtml += s <= stars ? '<i class="fa-solid fa-star"></i>' : '<i class="fa-regular fa-star"></i>';
    }

    const avatarHtml = photoUrl
      ? `<img src="${photoUrl}" alt="${name}" class="review-avatar-img" />`
      : `<div class="avatar-initials gradient-orange" style="width: 100%; height: 100%; border-radius: 50%;"><span>${initials}</span></div>`;

    newCard.innerHTML = `
      <div class="review-card-header">
        <div class="review-avatar-wrap">
          ${avatarHtml}
          <span class="review-verified-badge" title="Cliente Verificado"><i class="fa-solid fa-check"></i></span>
        </div>
        <div class="review-user-info">
          <strong class="review-user-name">${name}</strong>
          <span class="review-user-role">${role}</span>
          <span class="review-user-company"><i class="fa-solid fa-building"></i> ${company}</span>
        </div>
        <div class="review-rating-block">
          <div class="review-stars-gold">
            ${starsHtml}
          </div>
          <span class="review-score-tag">${stars}.0 / 5.0</span>
        </div>
      </div>
      <div class="review-service-pill">
        <span class="service-chip ${servInfo.class}"><i class="fa-solid ${servInfo.icon}"></i> ${servInfo.title}</span>
      </div>
      <p class="review-body-text">
        "${comment}"
      </p>
      <div class="review-card-footer">
        <span><i class="fa-solid fa-location-dot"></i> ${city}</span>
        <span class="review-date-text">${dateStr || 'Opinión Verificada'}</span>
      </div>
    `;

    reviewsTrack.insertBefore(newCard, reviewsTrack.firstChild);
    cards = Array.from(reviewsTrack.querySelectorAll('.review-card-modern'));
  }

  // Envío del Formulario de Reseña
  if (reviewForm) {
    reviewForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const name = document.getElementById('newReviewName')?.value.trim() || 'Cliente Satisfecho';
      const role = document.getElementById('newReviewRole')?.value.trim() || 'Gerente de Operaciones';
      const company = document.getElementById('newReviewCompany')?.value.trim() || 'Empresa Industrial';
      const city = document.getElementById('newReviewCity')?.value.trim() || 'Bogotá D.C.';
      const service = document.getElementById('newReviewService')?.value || 'alquiler';
      const comment = document.getElementById('newReviewComment')?.value.trim() || 'Excelente servicio y puntualidad.';
      const stars = selectedStars;
      const photoUrl = userSelectedPhotoBase64 || '';
      const dateStr = 'Justo ahora • Opinión Verificada';

      const reviewData = {
        name,
        role,
        company,
        city,
        service,
        stars,
        comment,
        photoUrl,
        dateStr,
        createdAt: new Date().toISOString()
      };

      // 1. Renderizar e insertar inmediatamente la nueva reseña en pantalla
      renderAndPrependReview(reviewData, true);

      // 2. Guardar en LocalStorage para persistencia local inmediata
      try {
        const saved = JSON.parse(localStorage.getItem('serpromaq_user_reviews') || '[]');
        saved.push(reviewData);
        localStorage.setItem('serpromaq_user_reviews', JSON.stringify(saved));
      } catch (err) {
        console.warn('LocalStorage save note:', err);
      }

      // 3. Sincronizar en segundo plano con Firebase (sin bloquear la interfaz)
      (async () => {
        try {
          let cloudPhotoUrl = photoUrl;
          if (userSelectedPhotoFile) {
            try {
              const fileExt = userSelectedPhotoFile.name.split('.').pop();
              const storageRefPath = `resenas/${Date.now()}_${name.replace(/[^a-zA-Z0-9]/g, '_')}.${fileExt}`;
              const fileStorageRef = ref(storage, storageRefPath);
              const snapshot = await uploadBytes(fileStorageRef, userSelectedPhotoFile);
              cloudPhotoUrl = await getDownloadURL(snapshot.ref);
            } catch (stErr) {
              console.warn('Storage sync background note:', stErr);
            }
          }

          await addDoc(collection(db, 'resenas_clientes'), {
            nombre: name,
            cargo: role,
            empresa: company,
            ciudad: city,
            servicio: service,
            estrellas: stars,
            comentario: comment,
            foto_url: cloudPhotoUrl,
            fecha: new Date().toLocaleString('es-CO'),
            createdAt: serverTimestamp()
          });
        } catch (cloudErr) {
          console.warn('Cloud sync background note:', cloudErr);
        }
      })();

      // 4. Actualizar conteos y vista del carrusel
      updateCounts();

      // 5. Limpiar formulario y cerrar modal
      reviewForm.reset();
      if (btnRemovePhoto) btnRemovePhoto.click();
      closeReviewModal();

      // 6. Mensaje de confirmación instantáneo
      alert(`¡Muchas gracias por tu reseña, ${name}!\n\nTu opinión ha sido verificada y publicada con éxito.`);

      // 7. Volver a la primera página para mostrar la reseña
      currentPage = 0;
      updateCarousel();
    });
  }

  // Cargar reseñas guardadas y actualizar estado inicial
  loadPersistedUserReviews();
  updateCounts();
  updateCarousel();
}

